import { TMSDeliverySlotsArraySlot } from 'modules/delivery'

/**
 * Handle date change
 */
export const handleDateChange = (
  date: string,
  setSelectedDate: (date: string) => void
) => {
  setSelectedDate(date)
}

export const handleClearSelection = (
  setSelectedDeliverySlots: (
    slots:
      | TMSDeliverySlotsArraySlot[]
      | ((
          prevSlots: TMSDeliverySlotsArraySlot[]
        ) => TMSDeliverySlotsArraySlot[])
  ) => void
) => {
  setSelectedDeliverySlots([])
}
